import type { ReservationPartySelectorField } from '../Types/reservationTypes';

export type ReservationPartySearchReason = 'input' | 'clear' | 'open';

export const updateReservationPartySearchState = ({
  currentSearches,
  fieldName,
  inputValue,
  reason,
}: {
  currentSearches: Record<ReservationPartySelectorField, string>;
  fieldName: ReservationPartySelectorField;
  inputValue: string;
  reason?: ReservationPartySearchReason;
}) => ({
  activeFieldName: fieldName,
  searches: {
    ...currentSearches,
    [fieldName]: reason === 'open' ? '' : inputValue,
  },
});